module.exports = __webpack_public_path__ + "assets/img/bit.aeffe9fb.png";